import { smartLocalStorageClear } from '../utils/localStorageUtils'

const LOCAL_STORAGE_VERSION = "1.1.61";

// Проверяем версию localStorage и очищаем при необходимости
if (localStorage.LOCAL_STORAGE_VERSION != LOCAL_STORAGE_VERSION || localStorage.LOCAL_STORAGE_VERSION === null) {
    smartLocalStorageClear('обновление версии приложения');
}

// Устанавливаем текущую версию в localStorage
if (typeof localStorage.LOCAL_STORAGE_VERSION === 'undefined' || localStorage.LOCAL_STORAGE_VERSION === null) {
    localStorage.setItem('LOCAL_STORAGE_VERSION', LOCAL_STORAGE_VERSION);
}

// Сохраняем версию в глобальной переменной для использования в versionService
window.CLIENT_VERSION = LOCAL_STORAGE_VERSION;
